// extracted by mini-css-extract-plugin
export default {"mapTitle":"MapMainComponent_mapTitle__9XhXj"};